<app-sharepoint-table #taskGrid
                      *ngIf="_configuration"
                      class="task-template-table"
                      [configuration]="_configuration"
                      (onTooolbarButtonClick)="onTooolbarButtonClick($event)"
>
</app-sharepoint-table>
